"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var ImageBuffer_1 = __importDefault(require("./ImageBuffer"));
var Image_1 = __importDefault(require("../Image"));
var IMAGE_BUFFER_SIZE = 10;
function SmoothImage(props) {
    var className = props.className, src = props.src, rest = __rest(props, ["className", "src"]);
    var _a = (0, react_1.useState)([]), arr = _a[0], setArr = _a[1];
    // need access of arr in useEffect, use ref to prevent infinite loop
    var arrRef = (0, react_1.useRef)(arr);
    (0, react_1.useEffect)(function () {
        if (src) {
            arrRef.current.push({
                // new key for each image to trigger animation,
                // or react will use the cached one which doesn't have animation
                key: Date.now().toString(),
                src: src
            });
            // buffer size to prevent flashing under rapid clicking
            if (arrRef.current.length > IMAGE_BUFFER_SIZE) {
                // remove extra image over buffer size
                arrRef.current.shift();
            }
            // create a new array to trigger render
            setArr(__spreadArray([], arrRef.current, true));
        }
    }, [src]);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Image_1.default, __assign({}, rest, { className: className, src: src })),
        arr.map(function (x) { return (react_1.default.createElement(ImageBuffer_1.default, __assign({ key: x.key }, rest, { className: className, src: x.src }))); })));
}
exports.default = SmoothImage;
var Container = (0, styled_1.default)(Box_1.default)({
    position: 'relative',
    width: '100%',
    height: '100%'
});
